/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Field_Assignee_None_EligibleInputs */

const en_task_field_assignee_none_eligible = /** @type {(inputs: Task_Field_Assignee_None_EligibleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No user is allowed to be assigned this type of task`)
};

const pt_br2_task_field_assignee_none_eligible = /** @type {(inputs: Task_Field_Assignee_None_EligibleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum usuário pode ser responsável por este tipo de atividade`)
};

/**
* | output |
* | --- |
* | "No user is allowed to be assigned this type of task" |
*
* @param {Task_Field_Assignee_None_EligibleInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_field_assignee_none_eligible = /** @type {((inputs?: Task_Field_Assignee_None_EligibleInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Field_Assignee_None_EligibleInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_field_assignee_none_eligible(inputs)
	return pt_br2_task_field_assignee_none_eligible(inputs)
});